<mat-toolbar class="toolbar z-depth-1-half" [style.height]="toolbarHeight">
  <mat-icon class="hamburger" (click)="sidenav.toggle()">menu</mat-icon>
  <span [style.font-size]="toolbarTextSize">
    Health System Dynamics (HSD)
  </span>
  <img id="cns-logo"
    src="assets/cns-logo.png"
    title="Cyberinfrastructure for Network Science Center"
    [style.width]="logoWidth"
    [style.height]="logoHeight"/>
</mat-toolbar>

<mat-sidenav-container>
    <mat-sidenav #sidenav mode="side"
      [opened] = "true"
      class="sidenav-container"
      [style.width]="sidenavWidth">
        <p class="sidenav-title">Legend</p>
        <hr>
        <app-legend (toggleLayout)="toggleLayout($event)" #legend>
        </app-legend>

        <!-- Fork me on GitHub Banner -->
        <a class="github-fork-ribbon left-bottom" href="https://github.com/cns-iu/hsd" data-ribbon="Fork me on GitHub" title="Fork me on GitHub">Fork me on GitHub</a>
        <!-- /Fork me on GitHub Banner -->
    </mat-sidenav>

    <mat-sidenav-content [style.margin-left]="sidenavWidth">
      <div class="main-content">
        <mat-tab-group [selectedIndex]="0" *ngIf="!isCompact; else compactSumTreeLayout" #tabs>
          <mat-tab label="Sum-Tree">
            <app-sum-tree
              [summaryType]="legend.summaryType"
              [colorField]="legend.colorField"
              [opacityField]="legend.opacityField"
              [isCompact]="isCompact"
              [width]="width"
              [height]="height"
              [autoresize]="autoresize">
            </app-sum-tree>
          </mat-tab>
        </mat-tab-group>

        <!-- For Compact View (without tab) -->
        <ng-template #compactSumTreeLayout>
          <app-sum-tree
          [summaryType]="legend.summaryType"
          [colorField]="legend.colorField"
          [opacityField]="legend.opacityField"
          [isCompact]="isCompact"
          [width]="width"
          [height]="height"
          [autoresize]="autoresize">
          </app-sum-tree>
        </ng-template>
      </div>
    </mat-sidenav-content>
</mat-sidenav-container>



// WEBPACK FOOTER //
// ./src/app/hsd-ui/home/home.component.html